import { useEffect, useState } from "react";
import { loadCostCategorieService } from "../services/costingService";

const useCostingCategories = () => {

    // Declartion part
    const [costCategories, setCostCategories] = useState([]);    
    const [isLoad, setLoad] = useState(false);

    const loadCostCategories = async (selectedID = null) => {
        try {
            const data = await loadCostCategorieService();

            if (data && data.length > 0) {
                setCostCategories(data);
            }
        }
        catch (error) {
            console.error("Error loading cost categories:", error);
            setCostCategories([]); // ✅ Handle error case

        }
        finally {
            setLoad(true);
        }

    };

    // load categories product
    useEffect(() => {
        if (!isLoad) {
            loadCostCategories();
        }
    }, [isLoad]);

    // load categories based on selection process
    const loadCostCategorySelection = async (selectedID) => {
        await loadCostCategories(selectedID);
    };

    return {
        costCategories,
        setCostCategories,
        loadCostCategorySelection,
    };

};
export default useCostingCategories;